import * as Constants from "../common/Constants";
import * as AccountType from "../common/AccountType";

const initialState = {
    journals: [],
    journalsByNo:[],
    journalModel: {},
    cashBankJournals: [],
    trialBalances: [],
    cashBankBalance: {
        cash: { debit: 0, credit: 0 },
        bank: { debit: 0, credit: 0 }
    },
    totalOpeningBalance: { debit: 0, credit: 0 },
    isLoading: false,
    isTrialBalanceLoading: false,
    isPosting: false,
    isPosted: false,
    error: null
};


export default function journalReducer(state = initialState, action) {
    const newState = { ...state };
    newState.error = null;

    switch (action.type) {
        
        case Constants.REQUEST_CASH_BANK_JOURNALS:
        case Constants.REQUEST_JOURNALS:
            newState.isLoading = true;
            newState.isPosted = false;
            newState.isPosting = false;
            return newState;

        case Constants.REQUEST_FOR_TRIAL_BALANCE:
            newState.isTrialBalanceLoading = true;
            newState.isPosted = false;
            newState.isPosting = false;
            return newState;

        case Constants.RECEIVE_JOURNALS:
            
            newState.isLoading = false;
            newState.isPosted = false;
            newState.isPosting = false;
            if (action.journalModel) {
                newState.journalModel = action.journalModel;
            }else if (action.journalsByNo) {
                newState.journalsByNo = action.journalsByNo;
            } else {
                newState.journals = action.journals;
            }
            return newState;

        case Constants.RECEIVE_TRIAL_BALANCE:
            newState.isTrialBalanceLoading = false;
            newState.trialBalances = action.payload;
            return newState;

        case Constants.RECEIVE_CASH_BANK_BALANCE:
            newState.cashBankBalance = action.cashBankBalance;
            newState.isLoading = false;
            return newState;

        case Constants.RECEIVE_ACCOUNT_TOTAL_BALANCE:
            
            var nm = Object.keys(AccountType).find(a => AccountType[a] === action.payload.accountId);
            if (typeof nm === "undefined") {
                nm = `acc_${action.payload.accountId}`;
            }
            if (action.payload.data) {
                newState[nm + "_last"] = action.payload.data[0];
                newState[nm + "_this"] = action.payload.data[1];
            } else {
                newState[nm] = action.payload;
            }
            newState.isLoading = false;
            return newState;

        case Constants.RECEIVE_TOTAL_OPENING_BALANCE:
            newState.totalOpeningBalance = action.totalOpeningBalance;
            newState.isLoading = false;
            return newState;
            
        case Constants.SUCCESS_CASH_BANK_JOURNALS:
            newState.isLoading = false;
            newState.isPosted = false;
            newState.isPosting = false;
            newState.cashBankJournals = action.payload;
            return newState;

        case Constants.FAILED_CASH_BANK_JOURNALS:
        case Constants.FAILED_JOURNALS:
        case Constants.FAILED_TO_GET_TRIAL_BALANCE:
            newState.isLoading = false;
            newState.isPosted = false;
            newState.isPosting = false;
            newState.error = (action.error.response || { status: 0 }).status === 404 ? null : action.error;
            return newState;

        case Constants.REQUEST_ADD_NEW_JOURNAL:
        case Constants.REQUEST_UPDATE_JOURNAL:
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_NEW_JOURNAL:
            newState.isPosting = false;
            newState.isPosted = true;
            newState.newJournals = action.newJournals;
            newState.journalsByNo = [];
            return newState;

        case Constants.SUCCESS_UPDATE_JOURNAL:
            newState.isPosting = false;
            newState.isPosted = true;
            newState.newJournals = action.newJournals;
            newState.journals = [];
            newState.journalsByNo = [];
            return newState;

        case Constants.FAILED_UPDATE_JOURNAL:
            newState.isPosting = false;
            newState.error = (action.error.response || { status: 0 }).status === 404 ? null : action.error;
            console.log(action.error);
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/JournalReducer.js